import React from "react";

export const ContainerTab = ({ tabs = [{ name: "test", id: 0 }], selectTab = 0, onClickTab = () => {}, children }) => {
	return (
		<div className="">
			<div className="w-full overflow-x-scroll scroll-project-details flex gap-1 cursor-pointer">
				{tabs.map((tab, index) => (
					<div
						onClick={() => {
							onClickTab(index);
						}}
						key={`${index}-tabs-data`}
						className={`bg-[#F5F5F5] p-2 rounded-t-[5px] border-[2px] border-[#CDCDCD] ${selectTab === index && "font-semibold"}`}
					>
						{tab.name}
					</div>
				))}
			</div>
			{children}
		</div>
	);
};
